export enum DataMapDrawerPropsEnums {
  CLICK_HERE = 'Click here to view more',
  CLICK_HERE_LESS = 'Click here to view less',
  LOADING_PLACEHOLDER_TEXT = 'Fill the entries to get the data',
  ABSOLUTE_POSITION = 'absolute',
  DIV_ELEMENT = 'div',
  STAGE_1 = 'stage1',
  STAGE_2 = 'stage2',
  STAGE_3 = 'stage3',
  LOADING_ELEMENT_STAGE_3_X_POSITION = '800px',
  LOADING_ELEMENT_STAGE_3_Y_POSITION = '400px',
  LOADING_ELEMENT_STAGE_2_X_POSITION = '470px',
  LOADING_ELEMENT_STAGE_2_Y_POSITION = '380px',
}
